import React from 'react';
import { Helmet } from 'react-helmet';

import ForgotContainer from './components/presentational/ForgotContainer';
import useScript from '../../shared/hooks/useScript';
import BackgroundSlidesPageContainer from '../login/components/shared/BackgroundSlidesPageContainer';
import PageWrapper from '../login/components/shared/PageWrapper';
import useBackgroundSlides, { createLoginSlides } from '../login/components/hooks/useBackgroundSlides';

const slides = createLoginSlides(12);

const ForgotPassword = () => {
  const { imageTransition } = useBackgroundSlides(slides);

  useScript('https://cdn.ywxi.net/js/1.js');

  return (
    <BackgroundSlidesPageContainer imageTransition={imageTransition}>
      <Helmet>
        <title>Forgot Password | Teambuildr</title>
      </Helmet>
      <PageWrapper>
        <ForgotContainer />
      </PageWrapper>
    </BackgroundSlidesPageContainer>
  );
};

export default ForgotPassword;
